import { render, staticRenderFns } from "./PromocodesTable.vue?vue&type=template&id=a498c9da"
import script from "./PromocodesTable.vue?vue&type=script&lang=js"
export * from "./PromocodesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports